import script from "./globalSearchTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./globalSearchTab.vue?vue&type=script&setup=true&lang=ts"

import "./globalSearchTab.vue?vue&type=style&index=0&id=66dcec23&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66dcec23"]])

export default __exports__